import { useLang } from "./LangContext";
import { MaskLine, Reveal } from "./Reveal";

export default function Intro() {
  const { t } = useLang();

  return (
    <section
      data-testid="intro-section"
      className="border-t border-border px-6 py-28 md:px-12 md:py-44"
    >
      <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
        <div className="md:col-span-3">
          <span className="label">02 — Intro</span>
        </div>
        <div className="md:col-span-9">
          <h2 className="font-display text-4xl font-medium leading-[0.95] tracking-tight md:text-6xl lg:text-7xl">
            {t.intro.statement.map((line, i) => (
              <MaskLine key={i} delay={i * 0.08}>
                {line}
              </MaskLine>
            ))}
          </h2>
          <Reveal delay={0.2}>
            <p className="mt-12 max-w-2xl text-lg leading-relaxed text-muted-foreground md:text-xl">
              {t.intro.paragraph}
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
